import { Clock, Facebook, Instagram, MapPin, MessageCircle, Music2 } from "lucide-react";
import { PICKUP_ADDRESS, SOCIALS, WHATSAPP_LINK } from "@/config";

export default function Contacto() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8" data-testid="contacto-page">
      <p className="font-script font-semibold text-3xl text-orange">Aquí andamos</p>
      <h1 className="mt-2 font-script text-4xl font-semibold text-cocoa sm:text-5xl">Contacto</h1>

      <div className="mt-12 grid gap-8 lg:grid-cols-2">
        <div className="space-y-6">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-whatsapp-card"
            className="flex items-center gap-4 rounded-2xl border border-sand bg-white p-6 transition-colors hover:border-[#25D366]"
          >
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366]/10 text-[#25D366]">
              <MessageCircle size={26} />
            </span>
            <div>
              <h2 className="font-script text-xl font-semibold text-cocoa">WhatsApp</h2>
              <p className="text-sm text-clay">La vía más rápida: soporte, dudas y citas de pick up.</p>
            </div>
          </a>

          <div className="flex items-center gap-4 rounded-2xl border border-sand bg-white p-6">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-habanero/10 text-habanero">
              <MapPin size={26} />
            </span>
            <div>
              <h2 className="font-script text-xl font-semibold text-cocoa">Punto de pick up</h2>
              <p className="text-sm text-clay">{PICKUP_ADDRESS}</p>
            </div>
          </div>

          <div className="flex items-center gap-4 rounded-2xl border border-sand bg-white p-6">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-corn/20 text-cocoa">
              <Clock size={26} />
            </span>
            <div>
              <h2 className="font-script text-xl font-semibold text-cocoa">Horario de atención</h2>
              <p className="text-sm text-clay">
                WhatsApp: 9:00 a 21:00 · Pick up: lun-jue 4:00-7:00 p.m. · Domicilio: lun-jue 7:00-10:00 p.m.
              </p>
            </div>
          </div>

          <div className="rounded-2xl border border-sand bg-white p-6">
            <h2 className="font-script text-xl font-semibold text-cocoa">Síguenos</h2>
            <div className="mt-4 flex gap-3">
              <a href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" data-testid="contact-instagram" aria-label="Instagram" className="flex h-12 w-12 items-center justify-center rounded-full border border-sand text-cocoa transition-colors hover:bg-habanero hover:text-white">
                <Instagram size={20} />
              </a>
              <a href={SOCIALS.tiktok} target="_blank" rel="noopener noreferrer" data-testid="contact-tiktok" aria-label="TikTok" className="flex h-12 w-12 items-center justify-center rounded-full border border-sand text-cocoa transition-colors hover:bg-habanero hover:text-white">
                <Music2 size={20} />
              </a>
              <a href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" data-testid="contact-facebook" aria-label="Facebook" className="flex h-12 w-12 items-center justify-center rounded-full border border-sand text-cocoa transition-colors hover:bg-habanero hover:text-white">
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="overflow-hidden rounded-2xl border border-sand bg-white">
          <iframe
            title="Mapa del punto de pick up — Fraccionamiento Las Américas, Mérida"
            src="https://www.google.com/maps?q=Fraccionamiento+Las+Am%C3%A9ricas,+M%C3%A9rida,+Yucat%C3%A1n,+M%C3%A9xico&output=embed"
            className="h-full min-h-[420px] w-full"
            loading="lazy"
            data-testid="pickup-map"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}
